import { useTranslation } from "@msuite/ui/localization";
import { ProgressMeter } from "@msuite/ui/progress-meter";
import { guardArray, uniqueArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { guardNumber } from "@msuite/utils/numbers";
import type { SubstitutionPlanFrontendFormSchema } from "@msuite/utils/schemas";
import { useId } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSubstitutionPlanFormContext } from "@/forms/substitution-plan-form/context";

export function SubstitutionPlanOverview() {
	/** Context */
	const { startDate, endDate, validation } = useSubstitutionPlanFormContext();
	const methods = useFormContext<SubstitutionPlanFrontendFormSchema>();
	const items = useWatch({ control: methods.control, name: "items" });
	const renderId = useId();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const guardedItems = guardArray(items);

	const projectsLength = guardedItems.length;
	const { invalidItemsLength } = validation;
	const answeredLength = projectsLength - invalidItemsLength;
	const numberOfSubstitutions = uniqueArray(guardedItems.flatMap((i) => i.assignedUserIds)).length;

	return (
		<div className="card p-0 *:card-padding h-stack divide-x-[0.5px] *:border-color gap-0">
			<div className="flex-1">
				<p>{moment().getDateSpanString([startDate, endDate])}</p>
			</div>
			<div className="h-stack gap-4">
				<div className="w-72">
					<ProgressMeter
						key={renderId}
						hideLabel
						value={(answeredLength / projectsLength) * 100}
					/>
				</div>
				<p>
					{answeredLength} / {projectsLength} {t("projects.projects")}
				</p>
			</div>
			<div>
				<p>{guardNumber(numberOfSubstitutions)} Managers selected</p>
			</div>
		</div>
	);
}
